module.exports = __webpack_public_path__ + "img/busd.5a518df4.webp";